<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'reports.leadExport.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      <app-report-filter-bar [includeAllUsers]="includeAllUsers" (filtersChange)="onFiltersChange($event)" />

      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg no-print">
          <app-spinner />
        </div>
      } @else if (bundles().length === 0) {
        <p class="empty-state" data-testid="lead-export-empty">{{ 'reports.leadExport.empty' | translate }}</p>
      } @else {
        <p class="lead-export-summary" data-testid="lead-export-summary">
          {{ 'reports.leadExport.summary' | translate: { count: bundles().length + '', photos: attachmentCount() + '' } }}
        </p>
      }
    </app-card-content>
    @if (canExport && bundles().length > 0) {
      <app-card-actions class="no-print">
        <app-button variant="outlined" (click)="exportCsv()" data-testid="export-csv-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportCsv' | translate }}
        </app-button>
        <app-button variant="outlined" (click)="exportXlsx()" data-testid="export-xlsx-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportXlsx' | translate }}
        </app-button>
        <app-button variant="filled" [disabled]="exporting()" (click)="exportZip()" data-testid="export-zip-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.leadExport.exportZip' | translate }}
        </app-button>
      </app-card-actions>
    }
  </app-card>
</div>
